import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import SubNav from 'ROOT_SOURCE/components/SubNav'
import SideBar from 'ROOT_SOURCE/components/SideBar'

import Netloan from './Netloan'
import RiskEdu from './RiskEdu'

import './index.scss'

const plates = [
    {
        text: '网贷知识普及',
        url: '/edu/netloan'
    },
    {
        text: '风险教育',
        url: '/edu/riskedu'
    }
]

const Edu = ({match}) => {
    return (
        <div className="Edu">
            <SubNav selected="edu" />
            <div className="main-box">
                <div className="main">
                    <SideBar plates={plates} />
                    <div className="section">
                        <Switch>
                            <Route path={`${match.url}/netloan`} component={Netloan} />
                            <Route path={`${match.url}/riskedu`} component={RiskEdu} />
                            <Redirect to={`${match.url}/netloan`} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Edu;


// WEBPACK FOOTER //
// ./src/containers/Edu/index.js